module.exports = __webpack_public_path__ + "img/bb_g1_t_eyes-03.066908dd.svg";